import { render } from "./VentureLogo.vue?vue&type=template&id=8970ca6c"
import script from "./VentureLogo.vue?vue&type=script&lang=js"
export * from "./VentureLogo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__